<div>
    <!-- <ion-item (click)="goTo('trc20')" lines="none" class="nav-content">
       <ion-label> TRC20 </ion-label>
     </ion-item> -->
    <ion-item (click)="goTo('news')" lines="none" class="nav-content">
        <ion-label> News</ion-label>
    </ion-item>
    <ion-item (click)="goTo('products')" lines="none" class="nav-content">
        <ion-label> I nostri prodotti</ion-label>
    </ion-item>
    <ion-item (click)="goTo('files')" lines="none" class="nav-content">
        <ion-label> File utili</ion-label>
    </ion-item>
    <ion-item (click)="goTo('faq-category')" lines="none" class="nav-content">
        <ion-label> FAQ</ion-label>
    </ion-item>
    <ion-item (click)="goTo('support')" lines="none" class="nav-content">
        <ion-label> Supporto</ion-label>
    </ion-item>
    <ion-item (click)="goTo('settings')" lines="none" class="nav-content">
        <ion-label> Impostazioni</ion-label>
    </ion-item>

    <!-- <ion-item (click)="goTo('force-bonus')" lines="none" class="nav-content">
      <ion-label> Test Bonus </ion-label>
    </ion-item> -->
</div>
